export function toSlug(str = '') {
  return (
    str
      // insert hyphens between lower→upper (camelCase → dash)
      .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
      // spaces or underscores → dash
      .replace(/[\s_]+/g, '-')
      // collapse multiple dashes
      .replace(/-+/g, '-')
      // lowercase
      .toLowerCase()
  )
}
